class HeaderSearch {
  constructor() {
    this.searchInputs = document.querySelectorAll('.header__search input[type="search"]');
    this.searchSuggestions = document.getElementById('search-suggestions');
    this.searchModal = document.querySelector('.search-modal');
    
    this.mobileSearchInput = document.getElementById('Search-In-Mobile');
    this.mobileSearchSuggestions = document.getElementById('mobile-search-suggestions');
    
    this.init();
  }

  init() {
    if (this.searchInputs.length && this.searchSuggestions) {
      this.searchInputs.forEach(input => {
        input.addEventListener('input', this.handleInput.bind(this));
        input.addEventListener('focus', this.handleFocus.bind(this));
        input.addEventListener('blur', this.handleBlur.bind(this));
      });
      this.observeModalState();
    }
    
    if (this.mobileSearchInput && this.mobileSearchSuggestions) {
      this.initMobileSearch();
    }
  }
  
  initMobileSearch() {
    const hasContent = this.mobileSearchSuggestions.querySelector('.search-suggestions__mobile');
    if (!hasContent) return;
    
    this.mobileSearchInput.addEventListener('input', (e) => {
      this.handleMobileInput(e);
    });
    
    this.mobileSearchInput.addEventListener('focus', (e) => {
      this.handleMobileFocus(e);
    });
    
    this.mobileSearchInput.addEventListener('blur', (e) => {
      this.handleMobileBlur(e);
    });
    
    const mobileSearchBar = document.getElementById('mobile-search-bar');
    if (mobileSearchBar) {
      const predictiveSearch = mobileSearchBar.querySelector('predictive-search');
      if (predictiveSearch) {
        const predictiveSearchResults = predictiveSearch.querySelector('[data-predictive-search]');
        if (predictiveSearchResults) {
          const observer = new MutationObserver(() => {
            const hasResults = predictiveSearchResults.innerHTML.trim();
            if (hasResults) {
              this.hideMobileSuggestions();
            } else if (!this.mobileSearchInput.value.trim()) {
              this.showMobileSuggestions();
            }
          });
          observer.observe(predictiveSearchResults, { childList: true, subtree: true });
        }
      }
    }
  }
  
  handleMobileInput(event) {
    const value = event.target.value.trim();
    if (value.length > 0) {
      this.hideMobileSuggestions();
    } else {
      this.showMobileSuggestions();
    }
  }
  
  handleMobileFocus(event) {
    const value = event.target.value.trim();
    if (value.length === 0) {
      this.showMobileSuggestions();
    }
  }
  
  handleMobileBlur(event) {
    setTimeout(() => {
      const relatedTarget = event.relatedTarget || document.activeElement;
      const mobileSearchSuggestions = this.mobileSearchSuggestions;
      
      if (mobileSearchSuggestions && 
          !mobileSearchSuggestions.contains(relatedTarget) &&
          relatedTarget !== this.mobileSearchInput) {
        this.hideMobileSuggestions();
      }
    }, 200);
  }
  
  showMobileSuggestions() {
    if (this.mobileSearchSuggestions) {
      this.mobileSearchSuggestions.classList.add('active');
    }
  }
  
  hideMobileSuggestions() {
    if (this.mobileSearchSuggestions) {
      this.mobileSearchSuggestions.classList.remove('active');
    }
  }

  handleInput(event) {
    const value = event.target.value.trim();
    
    if (value.length > 0) {
      this.hideSuggestions();
    } else {
      this.showSuggestions();
    }
  }

  handleFocus(event) {
    const value = event.target.value.trim();
    
    if (value.length === 0) {
      this.showSuggestions();
    }
  }

  handleBlur(event) {
    setTimeout(() => {
      this.hideSuggestions();
    }, 200);
  }

  showSuggestions() {
    if (this.searchSuggestions) {
      this.searchSuggestions.style.display = 'block';
      this.searchSuggestions.style.opacity = '1';
    }
  }

  hideSuggestions() {
    if (this.searchSuggestions) {
      this.searchSuggestions.style.opacity = '0';
      setTimeout(() => {
        this.searchSuggestions.style.display = 'none';
      }, 300);
    }
  }

  observeModalState() {
    if (!this.searchModal) return;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          const isOpen = this.searchModal.hasAttribute('open');
          
          if (isOpen) {
            const activeInput = document.querySelector('.header__search input[type="search"]:focus');
            if (activeInput && activeInput.value.trim().length === 0) {
              this.showSuggestions();
            }
          } else {
            this.hideSuggestions();
          }
        }
      });
    });

    observer.observe(this.searchModal, {
      attributes: true,
      attributeFilter: ['open']
    });
  }

  reset() {
    this.showSuggestions();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new HeaderSearch();
});

if (typeof module !== 'undefined' && module.exports) {
  module.exports = HeaderSearch;
}
